import { render, staticRenderFns } from "./AddDressModal.vue?vue&type=template&id=dd51be62&scoped=true"
import script from "./AddDressModal.vue?vue&type=script&lang=js"
export * from "./AddDressModal.vue?vue&type=script&lang=js"
import style0 from "./AddDressModal.vue?vue&type=style&index=0&id=dd51be62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd51be62",
  null
  
)

export default component.exports